import classNames from 'classnames';
import React from 'react';

import { Icon, IconTime, IconWarningStrongSolid, IconWheel } from '@flixbus/honeycomb-icons-react';

import { ASSIGNMENT_STATUSES } from 'pages/RideDetails/components/Assigment/const';
import { ASSIGNMENT_LABEL_TEXT } from 'pages/RideDetails/components/Assigment/text';

import styles from './styles.module.css';

const AssigmentDuration = ({ timeStat, status, isVoided }) => {
	const durationStyles = classNames({
		[styles.assignmentsDuration]: true,
		[styles.rejected]: status === ASSIGNMENT_STATUSES.REJECTED,
		[styles.confirmed]: status === ASSIGNMENT_STATUSES.CONFIRMED,
		[styles.finished]: status === ASSIGNMENT_STATUSES.ACTUAL,
		[styles.live]: status === ASSIGNMENT_STATUSES.LIVE,
	});

	return (
		<div className={durationStyles}>
			<div className={styles.line} />
			{isVoided ? (
				<div className={styles.wrapperDuration}>
					<Icon InlineIcon={IconWarningStrongSolid} size={3} />
					<span>{ASSIGNMENT_LABEL_TEXT.postBreakdown}</span>
				</div>
			) : (
				<div className={styles.wrapperDuration}>
					<Icon InlineIcon={IconTime} extraClasses={styles.clock} size={3} />
					<span>{timeStat.wholeTimeLabel}</span> /
					<Icon InlineIcon={IconWheel} />
					<span>{timeStat.drivingTimeLabel}</span>
				</div>
			)}
		</div>
	);
};

export default AssigmentDuration;
